import { render, staticRenderFns } from "./DetailTransaction.vue?vue&type=template&id=d1fbe8d6&scoped=true&"
import script from "./DetailTransaction.vue?vue&type=script&lang=js&"
export * from "./DetailTransaction.vue?vue&type=script&lang=js&"
import style0 from "./DetailTransaction.vue?vue&type=style&index=0&id=d1fbe8d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1fbe8d6",
  null
  
)

export default component.exports